var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15",
    gradientUnits: "userSpaceOnUse",
    x1: 298.788,
    x2: 357.212,
    y1: 113.212,
    y2: 54.788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#cacad5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcdce3"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_13",
    gradientUnits: "userSpaceOnUse",
    x1: 200.78,
    x2: 455.22,
    y1: 399.22,
    y2: 144.78
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d46669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd888a"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    gradientUnits: "userSpaceOnUse",
    x1: 231.878,
    x2: 424.122,
    y1: 368.122,
    y2: 175.878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#606082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83839e"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    gradientUnits: "userSpaceOnUse",
    x1: 293.515,
    x2: 362.485,
    y1: 70.485,
    y2: 1.515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#f8c73f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fada7f"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-2",
    x1: 235.393,
    x2: 424.122,
    xlinkHref: "#New_Gradient_Swatch_5",
    y1: 364.607,
    y2: 175.878
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_16-express",
    "data-name": "16-express"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gradient"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344 44h-32c-4.418 0-8 5.373-8 12v56c0 6.627 3.582 12 8 12h32c4.418 0 8-5.373 8-12v-56c0-6.627-3.582-12-8-12z",
    fill: "url(#New_Gradient_Swatch_15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 164a12 12 0 0 1 -8.485-20.485l24-24a12 12 0 1 1 16.97 16.97l-24 24a11.963 11.963 0 0 1 -8.485 3.515z",
    fill: "#a6a6b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 164a11.963 11.963 0 0 1 -8.485-3.515l-24-24a12 12 0 1 1 16.97-16.97l24 24a12 12 0 0 1 -8.485 20.485z",
    fill: "#a6a6b9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 272,
    fill: "url(#New_Gradient_Swatch_13)",
    r: 180
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 272,
    fill: "url(#New_Gradient_Swatch_3)",
    r: 136
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#New_Gradient_Swatch_5)",
    height: 48,
    rx: 12,
    width: 104,
    x: 276,
    y: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328 136v130a6 6 0 0 0 6 6h130c0-74.991-61.009-136-136-136z",
    fill: "url(#New_Gradient_Swatch_5-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 212h-80a12 12 0 0 1 0-24h80a12 12 0 0 1 0 24z",
    fill: "#fada7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 308h-80a12 12 0 0 1 0-24h80a12 12 0 0 1 0 24z",
    fill: "#fada7f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f9cd55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128 356h-56a12 12 0 0 1 0-24h56a12 12 0 0 1 0 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 260h-104a12 12 0 0 1 0-24h104a12 12 0 0 1 0 24z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.44f5ec717c3c64bddcc331244afd8401.svg";
export { ForwardRef as ReactComponent };